import { useQuery } from '@apollo/client/react';

import { GET_USER } from '@atom/graph/user';
import { GET_WORK_ORDERS } from '@atom/graph/work';
import { UserDetail } from '@atom/types/user';
import { WorkOrder } from '@atom/types/work';

export type UserSidebarData = {
  user: UserDetail | undefined;
  workOrders: WorkOrder[];
  loading: boolean;
  error: boolean;
};

const useUserSidebarData = (id: string): UserSidebarData => {
  const {
    loading: userLoading,
    data: userData,
    error: userError,
  } = useQuery(GET_USER, {
    variables: { id },
    fetchPolicy: 'no-cache',
    skip: !id,
  });

  const { loading: workOrdersLoading, data: workOrdersData } = useQuery(
    GET_WORK_ORDERS,
    {
      variables: {
        input: {
          userIds: [id],
          sortBy: 'dueDate,asc',
          page: 1,
          limit: 250,
          statusIds: [1, 2, 3, 4],
        },
      },
      fetchPolicy: 'no-cache',
      skip: !id,
    },
  );

  return {
    user: userData?.user,
    workOrders: (workOrdersData?.workOrders?.workOrders ?? []) as WorkOrder[],
    loading:
      (userLoading && !userData) || (workOrdersLoading && !workOrdersData),
    error: Boolean(userError),
  };
};

export default useUserSidebarData;
